import React from 'react';
import Edit from '@material-ui/icons/Edit';
import { countText } from '@app/helpers';
import { PasslyButton } from '@app/components';

interface IProps {
    icon: string;
    bottomLabel: string;
    count: number;
    action: Function;
    synced?: boolean;
}

const CardCountEdit: React.SFC<IProps> = ({ icon, bottomLabel, count, action, synced }) => {

    return (
        <div className={'cardCountEdit__card'}>
            <div className={'cardCountEdit__card-icon'} onClick={() => action()}>
                <i className={`icon ${icon}`} />
            </div>

            <div className='cardCountEdit__card-bottom horizontal'>
                <div className={'cardCountEdit__card-title'}>{countText(count, bottomLabel)}</div>
                {!synced &&
                    (
                        <PasslyButton style={{ backgroundColor: 'transparent' }} onClick={() => action()}>
                            <Edit className={'cardCountEdit__card-edit'} />
                        </PasslyButton>
                    )
                }
            </div>
        </div>
    );
};

export default CardCountEdit;
